import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import {Avatar, Button, Col, Descriptions, Divider, Row} from 'antd';
import {FcCheckmark} from 'react-icons/all';
import {DEFAULT_AVATAR_URL} from 'shared/constants/AppConst';
import {PatientContext} from '../PatientContext';
import PatientEditor from '../PatientEditor';
import {addressText} from 'utils/Utils';

const PatientInfo = () => {
  const intl = useIntl();

  const patientContext = useContext(PatientContext);
  const {selectedPatient, setEditing} = patientContext;

  const onEdit = () => {
    setEditing(true);
  };

  return (
    <>
      <Row gutter={16}>
        <Col span={4}>
          <Avatar
            style={{
              width: '60%',
              height: '150px',
              marginLeft: '20%',
              marginRight: '20%',
            }}
            src={selectedPatient?.photoUrl || DEFAULT_AVATAR_URL}
          />
        </Col>
        <Col span={20}>
          <Descriptions
            bordered
            title={selectedPatient?.name}
            size='middle'
            style={{paddingTop: 10}}
            extra={
              <Button type='primary' onClick={() => onEdit()}>
                {intl.messages['common.edit']}
              </Button>
            }>
            <Descriptions.Item label={intl.messages['patient.name']}>
              {selectedPatient?.name}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['common.enabled']}>
              {selectedPatient?.active ? <FcCheckmark /> : <></>}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['patient.idn']}>
              {selectedPatient?.idn}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['patient.ppn']}>
              {selectedPatient?.ppn}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['patient.hin']}>
              {selectedPatient?.hin}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['common.phoneNumber']}>
              {selectedPatient?.phone}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['common.email']}>
              {selectedPatient?.email}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['common.birthDate']}>
              {selectedPatient?.birthDate}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['common.gender']}>
              {selectedPatient?.gender
                ? intl.messages[
                    `common.gender.${selectedPatient?.gender.toLowerCase()}`
                  ]
                : ''}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['patient.nationality']}>
              {selectedPatient?.nationality?.name}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['address']} span={2}>
              {addressText(selectedPatient?.address)}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['patient.habit']} span={3}>
              {selectedPatient?.habit}
            </Descriptions.Item>
          </Descriptions>

          <Divider />

          <Descriptions
            bordered
            title={intl.messages['contact']}
            size='middle'
            style={{paddingTop: 10, paddingBottom: 10}}>
            <Descriptions.Item label={intl.messages['contact.name']}>
              {selectedPatient?.contact?.name}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['common.phoneNumber']}>
              {selectedPatient?.contact?.phone}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['common.email']}>
              {selectedPatient?.contact?.email}
            </Descriptions.Item>
            <Descriptions.Item label={intl.messages['address']}>
              {addressText(selectedPatient?.contact?.address)}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <PatientEditor />
    </>
  );
};

export default PatientInfo;
